import { render } from "./job-accepted-students.vue?vue&type=template&id=1589c491"
import script from "./job-accepted-students.vue?vue&type=script&lang=js"
export * from "./job-accepted-students.vue?vue&type=script&lang=js"
script.render = render

export default script